import React from 'react';
export default function LanguageComponent(props) {

const { surveyLanguageName, handleLanguage, langList, surveyLanguageRTL , template} = props;

let [showDrop, openLangModal ] = React.useState(false);

return(<>
{surveyLanguageRTL?
  <div dir="rtl" lang="ar" className="flex justify-between">

<div/>

<div className="lg:flex  border-r pr-3 m-4 items-center "><h1 onClick={() => openLangModal(!showDrop)} 
className="text-sm cursor-pointer">{surveyLanguageName}</h1>
<span onClick={() => openLangModal(!showDrop)} 
className="cursor-pointer material-icons">arrow_drop_down</span>

{showDrop ?
  <div className={"absolute "+(template==='v4' || 'v2' ?" top-10 ":" top-10 ")+"  z-10 left-10 bg-white shadow-xl w-auto  py-1.5  lang"} style={{ maxHeight: "150px", overflowY: 'auto' }}>
    {langList && langList.length > 0 ?
      langList.map((item) =>
      (surveyLanguageName !==item.name)?
        <span onClick={() => {
          handleLanguage(item)
          openLangModal(!showDrop)
        }} 
        className="cursor-pointer block text-xs w-full hover:bg-gray-100 py-1.5 px-4">{item.name}</span>
      :null
      ): null}
  </div>
  : null}

</div>


</div>
:
<div className="flex justify-between">

<div/>

<div className={template==="v2"?"lg:flex   pr-3 m-4 items-center w-24 p-2  rounded-lg ":
"lg:flex   pr-3 m-4 items-center w-24  rounded-lg" }>
  
      <div className='border border-gray-500 p-2 rounded-md flex '>
        <h1 onClick={() => openLangModal(!showDrop)} className="text-sm cursor-pointer font-semibold w-24">{surveyLanguageName}</h1>
        <span onClick={() => openLangModal(!showDrop)} 
        className="cursor-pointer material-icons">arrow_drop_down</span>
      </div>


{showDrop ?
<div className={"absolute "+(template==='v4' || 'v2' ?" top-12 ":" top-5 ")+" right-2 bg-white text-xs w-24 py-2 shadow-lg rounded-sm text-gray-700"} >

{surveyLanguageName!=="English"?
<>
<span onClick={() => {
        handleLanguage({
          "name":"English",
          "shortName":"en"
        })
        openLangModal(!showDrop)
      }} className="block px-4 py-1 hover:bg-gray-100">{"English"}</span>
</>
:null}



{langList && langList.length > 0 ?
      langList.map((item) =>
      (surveyLanguageName !==item.name)?
      <span onClick={() => {
        handleLanguage(item)
        openLangModal(!showDrop)
      }} className="block px-4 py-1 hover:bg-gray-100">{item.name}</span>
      :null
      ): null}
    </div>
: null}


</div>


</div>

}

</>
  );}